require('./loanSettlementsHeader.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ components
const { LabelFilterRange } = require('commonsComponents/labelFilterRange');
// @constants
const { DATE_PICKER_CUSTOM_LOCALE, DATE_PICKER_CUSTOM_DATE_FORMAT } = require('constants/commonsComponents');
// @utilities
const { formatText } = require('core/i18n').i18n;

class LoanSettlementsHeader extends React.Component {
    constructor(props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    buildFilterDateLabel() {
        const { immFilter } = this.props;
        const immFilterDate = immFilter.get('date');

        if (immFilter.get('isActive')) {
            const labelFromDate = immFilterDate.get('from').locale(DATE_PICKER_CUSTOM_LOCALE).format(formatText(DATE_PICKER_CUSTOM_DATE_FORMAT));
            const labelToDate = immFilterDate.get('to').locale(DATE_PICKER_CUSTOM_LOCALE).format(formatText(DATE_PICKER_CUSTOM_DATE_FORMAT));

            return (
                <LabelFilterRange
                    key="filter-date"
                    from={labelFromDate}
                    to={labelToDate}
                />
            );
        }
    }

    render() {
        const dateLabel = this.buildFilterDateLabel();

        return (
            <header className="loan-settlements-header">
                <div className="loan-settlements-header__labels">
                    {dateLabel}
                </div>
            </header>
        );
    }
}

LoanSettlementsHeader.propTypes = {
    immFilter: PropTypes.object.isRequired,
};

module.exports = LoanSettlementsHeader;
